import type {IOptionModel} from "@/models/option";
import {OrganizationStatus} from "./organization-status";
import {OrganizationType} from "./organization-type";
import type {FeatureToggle} from "@/constants/feature-toggle";
import type {PaginatedRequest} from "@/models/pagination";
import {type Address, DefaultAddress} from "@/models/relation/address";
import {SsoMappingType} from "@/constants/sso-mapping-type";

export interface Organization {
    id: number;
    name: string;
    type: OrganizationType;
    dataExeId: number | null,
    dataExeName: string | null;
    azureAdTenantId: string | null;
    promatieUrl: string | null;
    promatieSecretName: string | null;
    apeClientKey: string | null;
    featureToggles: FeatureToggle[];
    address: Address;
    status: OrganizationStatus;
    skipDataExeConnection: boolean;
    isDataExeLinked: boolean;
    ssoMappingType: SsoMappingType;
    graphGroupsConsentGranted: boolean;
}

export const DefaultOrganization = () => {
    return {
        id: 0,
        name: "",
        type: OrganizationType.DealerHolding,
        dataExeId: null,
        dataExeName: null,
        azureAdTenantId: null,
        promatieUrl: null,
        promatieSecretName: null,
        apeClientKey: null,
        status: OrganizationStatus.Active,
        featureToggles: [],
        address: DefaultAddress(),
        skipDataExeConnection: false,
        isDataExeLinked: false,
        ssoMappingType: SsoMappingType.None,
        graphGroupsConsentGranted: false,
    } as Organization
}

export interface OrganizationListModel {
    id: number;
    name: string;
    amountOfUsers: number;
    type: OrganizationType;
    status: OrganizationStatus;
    isProvisioned: boolean;
}

export interface OrganizationListRequest extends PaginatedRequest {
    name?: string;
    type?: OrganizationType;
    status?: OrganizationStatus;
}

export interface CheckedFeatureToggle extends IOptionModel<number> {
    checked: boolean
}


